"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapObject(obj, map) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        result[key] = map(value, key);
    }
    return result;
}
exports.mapObject = mapObject;
//# sourceMappingURL=utils.js.map